
import React, { useState, useEffect } from "react";
import data from "./data/data.json";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./views/Home";
import History from "./views/History";
import ConversationReview from "./views/ConversationReview";
import HomeDetailed from "./views/HomeDetailed";
import Assignments from "./views/Assignments";
import Analytics from "./views/Analytics";
import EasyMediumHard from "./views/EasyMediumHard";
import Training from "./views/Training";
import Doctor from "./views/Doctor";
import Family from "./views/Family";
import AgeAtHome from "./views/AgeAtHome";
import GuidedTraining from "./views/GuidedTraining";
import GuidedTrainingHome from "./views/GuidedTrainingHome";
import GuidedTrainingEsp from "./views/GuidedTrainingEsp";
import Certificate from "./views/Certificate";
import CaregiverQuiz from "./views/CaregiverQuiz";
import PrettyList from "./views/PrettyList";
import Login from "./views/Login";
import Configuration from "./views/Configuration";
import Coaching from "./views/Coaching";
import Coaching2 from "./views/Coaching2";
import CoachingHome from "./views/CoachingHome";
import Simulations from "./views/Simulations";
import Simulations2 from "./views/Simulations2";
import SessionScoresChart from "./views/SessionScoresChart";
import SessionFeedbackViewer from "./views/SessionFeedbackViewer";
import LogExportViewer from "./views/LogExportViewer";

const App = () => {
  const [user, setUser] = useState(null);
  const [view, setView] = useState("login");

  useEffect(() => {
    if (!user) setView("login");
  }, [user]);

  const handleLogin = (username, password) => {
    const foundUser = data.users.find(u => u.username === username && u.password === password);
    if (foundUser) {
      setUser(foundUser);
      setView("home");
    } else {
      alert("Invalid credentials");
    }
  };

  const logout = () => {
    setUser(null);
    setView("login");
  };

  const gotoanalytics = () => {
    setView("analytics");
  };

  const gotosimulations = () => {
    setView("simulations");
  };

  const gototraining = () => {
    setView("guidedtraininghome");
  };

  const gotocoaching = () => {
    setView("coachinghome");
  };

  if (!user) return <Login onLogin={handleLogin} />;

  const views = {
    home: <Home setView={setView} user={user} />,
    history: <History setView={setView} user={user} />,
    conversationreview: <ConversationReview setView={setView} user={user} />,
    homedetailed: <HomeDetailed setView={setView} />,
    assignments: <Assignments user={user} />,
    analytics: <Analytics setView={setView} />,
    easymediumhard: <EasyMediumHard user={user} gotoanalytics={gotoanalytics} />,
    doctor: <Doctor gotosimulations={gotosimulations} />,
    family: <Family gotosimulations={gotosimulations} />,
    ageathome: <AgeAtHome gotosimulations={gotosimulations} />,
    guidedtraining: <GuidedTraining gototraining={gototraining} />,
    guidedtraininghome: <GuidedTrainingHome setView={setView} />,
    guidedtrainingesp: <GuidedTrainingEsp gototraining={gototraining} />,
    certificate: <Certificate gotocoaching={gotocoaching} />,
    prettyList: <PrettyList />,
    logexportviewer: <LogExportViewer gotoanalytics={gotoanalytics} />,
    sessionscoreschart: <SessionScoresChart gotoanalytics={gotoanalytics} />,
    sessionfeedback: <SessionFeedbackViewer gotoanalytics={gotoanalytics} />,
    coaching: <Coaching gotocoaching={gotocoaching} />,
    coaching2: <Coaching2 user={user} />,
    coachinghome: <CoachingHome setView={setView} />,
    simulations: <Simulations setView={setView} />,
    simulations2: <Simulations2 setView={setView} />,
    caregiverquiz: <CaregiverQuiz setView={setView} />,
    configuration: <Configuration setView={setView} />,
    training: <Training gotosimulations={gotosimulations} />
  };

  return (
    <div>
      <Header logout={logout} goHome={() => setView("home")} />
      {views[view]}
      <Footer />
    </div>
  );
};

export default App;
